import { render, staticRenderFns } from "./AdminReportTable.vue?vue&type=template&id=56e39870"
import script from "./AdminReportTable.vue?vue&type=script&lang=js"
export * from "./AdminReportTable.vue?vue&type=script&lang=js"
import style0 from "./AdminReportTable.vue?vue&type=style&index=0&id=56e39870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports